/**
 * `useApprovalChains(projectId)` — the canonical read hook for the
 * project's approval chain list view.
 *
 * Thin `useQuery` wrapper over `approvalChainsQuery` so call sites get the
 * list with a single import while reads still flow through the queryOptions
 * helper (AD-20). The query stays idle until `projectId` is known.
 */
import { useQuery } from '@tanstack/react-query';

import { approvalChainsQuery } from './approval-chain.api';

export function useApprovalChains(projectId: string | undefined) {
  return useQuery(approvalChainsQuery(projectId));
}
